
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sandbox/ros-preview-alpha",
      function () {
        return require("private-next-pages/sandbox/ros-preview-alpha.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sandbox/ros-preview-alpha"])
      });
    }
  